import screenbanner from "./images/background/1.jpg";
import mobilebanner from "./images/background/2.jpg";

import m3m from "./images/property/altitude.webp";
import silverglades_59 from "./images/property/silverglades59.webp";
import silverglades from "./images/property/legacy.webp";
import smartworld from "./images/property/theedition.webp";


export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilebanner,
};

export const LocationData = {
  taglineheading: "Property In Golf Course Road Gurugram",
  locationtag: "",
  location: [
    {
      name: "Silverglades - Legacy",
      image: silverglades,
      price: "On Request",
      location: "Sector 63A",
      bed: "3 - 4 BHK",
      size: "....",
      url: `/silverglades-legacy`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Silverglades - Silverglades 59",
      image: silverglades_59,
      price: "On Request",
      location: "Sector 69",
      bed: "3 - 4 BHK",
      size: "....",
      url: `/silverglades`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "M3M - Altitude",
      image: m3m,
      price: "On Request",
      location: "Sector 65",
      bed: "4 BHK",
      size: "....",
      url: `/m3m-altitude`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Smartworld - Edition",
      image: smartworld,
      price: "On Request ",
      location: "Sector 66",
      bed: "3.5 - 4.5 BHK",
      size: "....",
      url: `/smartworld-the-edition`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    // {
    //   name: "Elevate - Elevate Reserve",
    //   image: m3m,
    //   price: "On Request",
    //   location: "Gurugram-62",
    //   bed: "1 - 3 BHK",
    //   size: "On Request",
    //   url: `/smartworld-the-edition`,
    // },
  ],
};